import initializeLoadContentSaga from './content/load-content'
import initializeSubmitFormSaga from './checkout-form/form-submission'
import initializeSubmitFormUcsSaga from './checkout-form/form-submission-ucs'
import initializeAbandonedCartSaga from './user/abandoned-cart'
import initializeExistingUserSaga from './user/existing-user'
import initializeCreateUserSaga from './user/create-user'
import initializeCreateUserUcsSaga from './user/create-user-ucs'
import initializeGetAccessToken from './user/get-token'
import initializeLogin from './user/login'
import initializeLogout from './user/logout'
import initializeGetLatestInvoiceSaga from './checkout-form/get-latest-invoice'
import initializeDownloadInvoiceSaga from './checkout-form/download-invoice'
import initializeLoadSavedStateSaga from './saved-state/saved-state'
import initializeCalculatePriceSaga from './checkout-form/calculate-price'
import initializeCreateBillingInfoSaga from './checkout-form/create-billing-info'
import initializeCreatePaymentSaga from './checkout-form/create-payment'
import initializeCreateAndSubmitPaymentSaga from './checkout-form/create-and-submit-payment'
import initializeGetPaymentMethodSaga from './checkout-form/get-payment-methods'
import initializeSubmitPaymentSaga from './checkout-form/submit-payment'
import initializeUserLoggedInSaga from './user/user-logged-in'
import initializeUserLoggedInUcsSaga from './user/user-logged-in-ucs'
import initializeExistingUserSubmitFormSaga from './checkout-form/existing-user-form-submission'
import initializeExistingUserSubmitFormUcsSaga from './checkout-form/existing-user-form-submission-ucs'
import initializeResetCheckoutFormAffectedStatesSaga from './checkout-form/reset-checkout-form-affected-states'
import initializeBuyTrackingSaga from './tracking/track-event'
import initializeCalculateVolumeDiscountSaga from './checkout-form/calculate-volume-discount'
import initializeGetSelectedTier from './checkout-form/get-selected-tier'
import initializeGetVolumeDiscountSaga from './checkout-form/get-volume-discount'
import initializeSetBillingFrequencySaga from './checkout-form/set-billing-frequency'
import initializeGetCouponDetailsSaga from './coupon/get-coupon-details'
import initializeAttempUrlCouponSaga from './coupon/attempt-url-coupon'

export const buySagas = {
    buyContentSaga: initializeLoadContentSaga,
    buySubmitFormSaga: initializeSubmitFormSaga,
    buySubmitFormUcsSaga: initializeSubmitFormUcsSaga,
    buyAbandonedCartSaga: initializeAbandonedCartSaga,
    buyExistingUserSaga: initializeExistingUserSaga,
    buyGetAccessToken: initializeGetAccessToken,
    buyUserLoginSaga: initializeLogin,
    buyUserLogoutSaga: initializeLogout,
    buyGetLatestInvoiceSaga: initializeGetLatestInvoiceSaga,
    buyDownloadInvoiceSaga: initializeDownloadInvoiceSaga,
    buyCreateUserSaga: initializeCreateUserSaga,
    buyCreateUserUcsSaga: initializeCreateUserUcsSaga,
    buyCalculatePriceSaga: initializeCalculatePriceSaga,
    buyCreateBillingInfoSaga: initializeCreateBillingInfoSaga,
    buyCreatePaymentSaga: initializeCreatePaymentSaga,
    buyCreateAndSubmitPaymentSaga: initializeCreateAndSubmitPaymentSaga,
    buyGetPaymentSaga: initializeGetPaymentMethodSaga,
    buySubmitPaymentSaga: initializeSubmitPaymentSaga,
    buyLoadSavedStateSaga: initializeLoadSavedStateSaga,
    buyUserLoggedInSaga: initializeUserLoggedInSaga,
    buyUserLoggedInUcsSaga: initializeUserLoggedInUcsSaga,
    buyExistingUserSubmitFormSaga: initializeExistingUserSubmitFormSaga,
    buyExistingUserSubmitFormUcsSaga: initializeExistingUserSubmitFormUcsSaga,
    buyResetCheckoutFormAffectedStates: initializeResetCheckoutFormAffectedStatesSaga,
    buyTrackingSaga: initializeBuyTrackingSaga,
    buyCalculateVolumeDiscountSaga: initializeCalculateVolumeDiscountSaga,
    buyGetVolumeDiscountSaga: initializeGetVolumeDiscountSaga,
    buyGetSelectedTierSaga: initializeGetSelectedTier,
    buySetBillingFrequencySaga: initializeSetBillingFrequencySaga,
    buyGetCouponDetailsSaga: initializeGetCouponDetailsSaga,
    buyAttemptUrlCouponSaga: initializeAttempUrlCouponSaga,
}

export default buySagas
